import { create } from "zustand";
import { FilterOperator } from "ui/partials/global-search/filters/OperatorSelect";
import { FilterCriteria } from "data/@types/GlobalSearchData";

export type AdvancedViewFilterType = {
  operator: FilterOperator;
  valueText: string | string[];
  valueDateRange: { from: Date | null; to: Date | null };
};

export type AdvancedViewFilterObject = {
  [key: string]: AdvancedViewFilterType;
};

type State = {
  filtersByActivity: { [activityType: string]: AdvancedViewFilterObject };
  meetingFilterCriteria: FilterCriteria | undefined;
  commentFilterCriteria: FilterCriteria | undefined;
};

type Actions = {
  setFiltersForActivity: (
    activityType: string,
    filters: AdvancedViewFilterObject,
  ) => void;
  clearFiltersForActivity: (activityType: string) => void;
  setMeetingFilterCriteria: (criteria: FilterCriteria | undefined) => void;
  setCommentFilterCriteria: (criteria: FilterCriteria | undefined) => void;
  resetAll: () => void;
};

type Store = State & Actions;

const initialState: State = {
  filtersByActivity: {},
  meetingFilterCriteria: undefined,
  commentFilterCriteria: undefined,
};

export const useAdvancedViewFiltersStore = create<Store>((set) => ({
  ...initialState,
  setFiltersForActivity: (activityType, filters) =>
    set((state) => ({
      filtersByActivity: {
        ...state.filtersByActivity,
        [activityType]: filters,
      },
    })),
  clearFiltersForActivity: (activityType) =>
    set((state) => {
      const rest = { ...state.filtersByActivity };
      delete rest[activityType];
      return { filtersByActivity: rest };
    }),
  setMeetingFilterCriteria: (criteria) =>
    set({ meetingFilterCriteria: criteria }),
  setCommentFilterCriteria: (criteria) =>
    set({ commentFilterCriteria: criteria }),
  resetAll: () => set(initialState),
}));
